import React, { useState, useEffect, useRef } from 'react'
import PublicLayout from '../../../layouts/PublicLayout'
import classes from './DetailCouse.module.css'
import BgHeaderEvent from '../../../assets/img/bg-event.webp'
import { Box, Container, Text, Button, Grid, Card, Rating, Flex, Group, List, rem, ThemeIcon, Avatar, Accordion, Badge, Modal, ActionIcon } from '@mantine/core'
import { IconNotebook, IconMessage, IconCertificate, IconFileDescription, IconLink, IconClipboardList, IconMaximize, IconExternalLink } from '@tabler/icons-react'
import { getImageFile } from '../../../services/fileImage'
// import { formatPrice } from '../../../plugins/formatPrice'
// import VideoIntroCourse from './VideoIntroCourse'
// import InfoCourse from './InfoCourse'
import ReviewProgram from '../Program/details/ReviewProgram'
// import TutorSection from '../Program/details/TutorSection'
import { useLocalStorage } from '@mantine/hooks'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { update } from '../../../store/cartData'
import { IconUsers } from '@tabler/icons-react'
import Plyr from 'plyr-react'
import Hls from "hls.js"
import { IconPlayerPlay, IconLock } from '@tabler/icons-react'
import { useViewportSize } from '@mantine/hooks'

import 'plyr-react/plyr.css'
import '../../../assets/css/hls-player.css'

const defaultRoute = {
  key: 'route',
  defaultValue: ''
}

const DetailCourse = ({ detail, loading }) => {
  const { width } = useViewportSize()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const [, setRoute] = useLocalStorage(defaultRoute)
  const { isLogin } = useSelector(state => state.auth)
  const [dataTutor, setDataTutor] = useState(null)

  const supportedHls = Hls.isSupported()

  const player = useRef(null)
  const [youtubeId, setYoutubeId] = useState(null)
  const [activeIndexCurriculum, setActiveIndexCurriculum] = useState(null)
  const [activeIndexSubCurriculum, setActiveIndexSubCurriculum] = useState(null)
  const [isModalPreviewOpen, setIsModalPreviewOpen] = useState(false)

  const selectedPlayedVideo = () => {
    if (activeIndexCurriculum !== null) {
      return detail.curriculums[activeIndexCurriculum].curriculumContents[activeIndexSubCurriculum].module
    }
    return ''
  }

  const defaultOptionsPlayer = {
    quality: {
      default: 360,
      options: [240, 360, 480, 720, 1080],
      forced: true,
      onChange: (e) => updateQualityPlayer(e),
    }
  }

  const updateQualityPlayer = (newQuality) => {
    if (window.hls && window.hls.levels && window.hls.levels.length > 0) {
      window.hls.levels.forEach((level, levelIndex) => {
        if (level.height === newQuality) {
          window.hls.currentLevel = levelIndex
        }
      })
    }
  }

  const checkUrlVideoYoutube = (url) => {
    const regex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
    if (url.match(regex)) {
      return url.match(regex)[1]
    }
    return false
  }

  const handleLoadVideo = async () => {
    if (activeIndexCurriculum !== null && activeIndexSubCurriculum !== null) {
      const activeContent = detail.curriculums[activeIndexCurriculum].curriculumContents[activeIndexSubCurriculum];
      if (activeContent.type !== 'video') return;
    }

    const selectedDataPlayer = selectedPlayedVideo()

    // Tunggu DOM update jika transisi dari file ke video
    setTimeout(() => {
      const videoPlayer = document.getElementById("plyr")
      if (!videoPlayer) return;

      const youtubeUrl = checkUrlVideoYoutube(selectedDataPlayer)
      if (!youtubeUrl) {
        setYoutubeId(null)
        var hls = new Hls()
        hls.loadSource(selectedDataPlayer)
        hls.attachMedia(videoPlayer)
        player.current.plyr.media = videoPlayer
        hls.on(Hls.Events.MEDIA_ATTACHED, function () {
          // eslint-disable-next-line
          hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
            for (let i = 0; i < data.levels.length; i++) {
              if (data.levels[i].height >= player.config.quality.default) {
                hls.currentLevel = i
                player.quality = player.config.quality.default
                break
              }
            }
          })
        })
      } else {
        setYoutubeId(youtubeUrl)
      }
    }, 100)

    // hls.on(Hls.Events.MANIFEST_PARSED, function () {
    //   player.current.plyr.play()
    // })
  }

  const handleGetPromotionVideo = (dataCurriculum) => {
    let found = false;
    for (let i = 0; i < dataCurriculum.length; i++) {
      for (let j = 0; j < dataCurriculum[i].curriculumContents.length; j++) {
        if (!dataCurriculum[i].curriculumContents[j].locked) {
          if (activeIndexCurriculum === null && !found) {
            setActiveIndexCurriculum(i)
            setActiveIndexSubCurriculum(j)
            found = true
          }
        }
      }
    }
  }

  useEffect(() => {
    if (activeIndexCurriculum !== null) {
      handleLoadVideo()
    }
    // eslint-disable-next-line
  }, [activeIndexCurriculum])



  useEffect(() => {
    if (detail) {
      handleGetDataTutor(detail.tutors)
      handleGetPromotionVideo(detail.curriculums)
    }
    // eslint-disable-next-line
  }, [detail])

  const handleGetDataTutor = (data) => {
    if (data.length > 0) {
      setDataTutor(data[0])
    }
  }

  const handleImage = (filepath) => {
    if (filepath.length > 0) {
      return getImageFile(detail.eventImages[0].filepath)
    } else {
      return BgHeaderEvent
    }
  }

  const handleCheckout = (scheduleId, schedulePrice) => {
    const data = {
      transactionMethodId: null,
      eventScheduleIds: [scheduleId],
      eventSlug: params.slug,
      totalPrice: schedulePrice
    }
    dispatch(update({ 'cart': data }))
    if (!isLogin) {
      navigate("/login")
      setRoute('/checkout')
    } else {
      navigate("/checkout")
    }
  }

  const mappingCountCurriculum = (dataCurriculum) => {
    if (dataCurriculum.length > 0) {
      const dataVideo = []
      const dataUrl = []
      const dataTask = []
      const dataModule = []

      for (let i = 0; i < dataCurriculum.length; i++) {
        const curriculumContent = dataCurriculum[i].curriculumContents
        for (let j = 0; j < curriculumContent.length; j++) {
          if (curriculumContent[j].type === 'video') {
            dataVideo.push(curriculumContent[j])
          }
          if (curriculumContent[j].type === 'url') {
            dataUrl.push(curriculumContent[j])
          }
          if (curriculumContent[j].type === 'task') {
            dataTask.push(curriculumContent[j])
          }
          if (curriculumContent[j].type === 'file') {
            dataModule.push(curriculumContent[j])
          }
        }
      }

      const handleShowData = (type, total) => {
        if (total > 0) {
          return (
            <List.Item
              my='sm'
              icon={
                <ThemeIcon color="red.6" size={24} radius="xl">
                  <IconNotebook style={{ width: rem(16), height: rem(16) }} />
                </ThemeIcon>
              }
              fw={600}
            >
              {total} {type}
            </List.Item>
          )
        }
      }

      return (
        <Box>
          {handleShowData('Modul', dataUrl.length + dataModule.length)}
          {handleShowData('Video', dataVideo.length)}
          {handleShowData('Task', dataTask.length)}
        </Box>
      )
    }
  }

  const infoDataTutor = (data) => {
    if (data !== null) {
      const innerHtml = { __html: data.shortProfile }
      return (
        <Card shadow="sm" padding="md" radius="md" withBorder style={{ backgroundColor: '#edf2ff' }} mt={14}>
          <Flex align='start'>
            <Avatar mr={16} radius='md' size={80} src={data.user.image !== "" ? getImageFile(data.user.image) : null} alt={data.user.fullName} />
            <Box>
              <Text fz="sm" mb={-10} fw="bold">{data.user.fullName}</Text>
              <Text fz="xs" fw='500' lineClamp={3} h={75}>{data.shortProfile ? (<Box dangerouslySetInnerHTML={innerHtml} />) : '-'}</Text>
            </Box>
          </Flex>
        </Card>
      )
    }
  }

  const mappingPreviewContent = (supportedHls) => {
    if (activeIndexCurriculum === null || activeIndexSubCurriculum === null) return null;
    const activeContent = detail.curriculums[activeIndexCurriculum].curriculumContents[activeIndexSubCurriculum];

    if (activeContent.type !== 'video') {
      return (
        <Box p="xl" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', textAlign: 'center', height: '100%', minHeight: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          {activeContent.type === 'file' && <IconFileDescription size={48} color="#fa5252" />}
          {activeContent.type === 'url' && <IconLink size={48} color="#fa5252" />}
          {activeContent.type === 'task' && <IconClipboardList size={48} color="#fa5252" />}

          <Text fw={600} mt="md" mb="sm">{activeContent.name}</Text>

          <Button
            variant="light"
            color="red"
            rightSection={<IconExternalLink size={16} />}
            onClick={() => {
              let url = activeContent.module;
              if (activeContent.type === 'file') {
                 url = `${process.env.REACT_APP_SERVER_API_URL}/files/storage/${activeContent.module}`;
              }
              window.open(url, '_blank')
            }}
          >
            {activeContent.type === 'file' ? 'Buka Dokumen' : (activeContent.type === 'url' ? 'Kunjungi Tautan' : 'Lihat Tugas')}
          </Button>
        </Box>
      )
    }

    if (supportedHls) {
      if (youtubeId === null) {
        return (
          <Plyr id='plyr' options={defaultOptionsPlayer} source={{}} ref={player} />
        )
      } else {
        return (
          <Plyr
            id='plyr'
            source={{
              type: 'video',
              sources: [
                {
                  src: youtubeId,
                  provider: 'youtube'
                }
              ]
            }}
            ref={player} />
        )
      }
    } else {
      return 'HLS is not supported in your browser'
    }
  }

  const handleRenderPlayer = () => {
    return (
      <Box>
        <Card shadow="sm" padding="xs" radius="md" w={{ base: '100%', md: 350 }} withBorder style={{ position: width > 768 ? 'fixed' : 'relative', zIndex: 0 }}>
          <Card.Section style={{ position: 'relative' }}>
            {mappingPreviewContent(supportedHls)}
            {activeIndexCurriculum !== null && (
              <ActionIcon
                variant="filled"
                color="dark"
                size="lg"
                radius="xl"
                style={{ position: 'absolute', top: 10, right: 10, opacity: 0.8 }}
                onClick={() => setIsModalPreviewOpen(true)}
              >
                <IconMaximize size={18} />
              </ActionIcon>
            )}
          </Card.Section>
          <Box mt={20}>
            <Button className={classes.buttonHeader} fullWidth mb={20} size='md' onClick={() => handleCheckout(detail.eventSchedules[0].id, detail.eventSchedules[0].price)}>Beli Sekarang</Button>
            <Box mb={12}>
              <Text fw={600} mb={8}>Yang Kalian Dapatkan</Text>
              <Box>
                <List spacing="xs" size="sm" center>
                  <List.Item
                    icon={
                      <ThemeIcon color="red.6" size={24} radius="xl">
                        <IconCertificate style={{ width: rem(16), height: rem(16) }} />
                      </ThemeIcon>
                    }
                    fw={600}
                  >
                    Sertifikat
                  </List.Item>
                  {mappingCountCurriculum(detail.curriculums)}
                  <List.Item
                    icon={
                      <ThemeIcon color="red.6" size={24} radius="xl">
                        <IconMessage style={{ width: rem(16), height: rem(16) }} />
                      </ThemeIcon>
                    }
                    fw={600}
                  >
                    Diskusi
                  </List.Item>
                </List>
              </Box>
            </Box>
          </Box>
        </Card>
      </Box>
    )
  }

  const mappingCurriculum = (curriculum) => {

    const remapCurriculumContent = (indexCurriculum, content) => {

      const changeVideoPromotion = (indexCurriculum, indexContent) => {
        setActiveIndexCurriculum(indexCurriculum)
        setActiveIndexSubCurriculum(indexContent)
        handleLoadVideo()
      }

      const mappingIconContent = (indexContent, isLocked, typeContent) => {
        if (!isLocked) {
          const isActive = indexContent === activeIndexSubCurriculum;
          const color = isActive ? 'red.6' : 'indigo.9';

          if (typeContent === 'video') return <ThemeIcon variant='white' color={color}><IconPlayerPlay stroke={1.5} size={18} /></ThemeIcon>;
          if (typeContent === 'file') return <ThemeIcon variant='white' color={color}><IconFileDescription stroke={1.5} size={18} /></ThemeIcon>;
          if (typeContent === 'url') return <ThemeIcon variant='white' color={color}><IconLink stroke={1.5} size={18} /></ThemeIcon>;
          if (typeContent === 'task') return <ThemeIcon variant='white' color={color}><IconClipboardList stroke={1.5} size={18} /></ThemeIcon>;

          return <ThemeIcon variant='white' color={color}><IconPlayerPlay stroke={1.5} size={18} /></ThemeIcon>;
        } else {
          return (
            <ThemeIcon variant='white' color='gray.5'>
              <IconLock stroke={1.5} size={18} />
            </ThemeIcon>
          )
        }
      }

      if (content.length > 0) {
        const remapDataContent = content.map((val, index) => {
          return (
            <Card shadow={0} radius={0} padding='xs' withBorder style={{ cursor: !val.locked ? 'pointer' : 'default' }} onClick={() => !val.locked ? changeVideoPromotion(indexCurriculum, index) : ''}>
              <Group gap='xs' align='center'>
                {mappingIconContent(index, val.locked, val.type)}
                <Text fz={12} fw={index === activeIndexSubCurriculum ? '600' : '500'} c={!val.locked ? '' : 'dimmed'}>{val.name}</Text>
                {val.isSample && (
                  <Badge size="xs" color="blue" variant="light">Sample</Badge>
                )}
              </Group>
            </Card>
          )
        })
        return remapDataContent
      }
    }

    if (curriculum.length > 0) {
      const remapCurriculum = curriculum.map((val, index) => {
        return (
          <Accordion.Item key={index} value={val.id}>
            <Accordion.Control style={{ padding: '4px 14px' }}>
              <Text fz={12} fw="bold">{val.name}</Text>
            </Accordion.Control>
            <Accordion.Panel>{remapCurriculumContent(index, val.curriculumContents)}</Accordion.Panel>
          </Accordion.Item>
        )
      })
      return remapCurriculum
    }
  }

  return (
    <PublicLayout>
      <Modal opened={isModalPreviewOpen} onClose={() => setIsModalPreviewOpen(false)} size="75%" title="Preview Materi" centered>
        <Box className="plyr-large" style={{ position: 'relative', width: '100%' }}>
          {mappingPreviewContent(supportedHls)}
        </Box>
      </Modal>
      <Box className={classes.bodyCourse}>
        <Box className={classes.headerCourse} style={{ backgroundImage: `linear-gradient(250deg, rgba(130, 201, 30, 0) 0%, #ece6e6 70%), url(${!loading ? handleImage(detail.eventImages) : ''})` }} />
        <Container fluid className={classes.section}>
          <Grid align="stretch">
            <Grid.Col span={{ base: 12, md: 8, lg: 8 }}>
              <Box py={250} h={700}>
                <Text className={classes.titleHeader} mb={16} lineClamp={3}>{detail.name}</Text>
                <Text className={classes.captionHeader} mb={24} lineClamp={4}>{detail.description}</Text>
                <Box mb={20}>
                  {detail.userRating ? (<Group align='center' gap={4} wrap='noWrap' mb='xs'><Rating size='md' defaultValue={detail.userRating} fractions={5} readOnly /><Text fw='bold' fz={12}>({detail.userRating}/5)</Text></Group>) : ''}
                  {detail.participantCount ? (<Group gap={4} align='center' wrap='noWrap'> <IconUsers size='1rem' stroke='1.5' /> <Text fz={12} fw='bold' lineClamp={1}>{detail.participantCount} User Terdaftar</Text></Group>) : ''}
                </Box>
              </Box>
              <Box mb='lg' hiddenFrom='md'>
                {handleRenderPlayer()}
              </Box>
              <Box mb='lg'>
                <Text fz="md" fw="bold">Belajar Bersama Tutor Profesional</Text>
                {infoDataTutor(dataTutor)}
              </Box>
              <Box mb='lg'>
                <Text fw="bold" mb={8}>Materi</Text>
                <Accordion radius={0} variant='separated' styles={{ content: { padding: '0px' }, item: { border: '1px solid #C1C2C5' } }}>
                  {mappingCurriculum(detail.curriculums)}
                </Accordion>
              </Box>
              <Box mb={200}>
                <ReviewProgram eventId={detail.id} />
              </Box>
            </Grid.Col>
            <Grid.Col span={4} visibleFrom="md">
              <Box pt={100}>
                {handleRenderPlayer()}
              </Box>
            </Grid.Col>
          </Grid>
        </Container>
      </Box>
    </PublicLayout>
  )
}

export default DetailCourse